import {
  compose,
  lifecycle,
  setDisplayName
} from 'recompose';
import {
  MAP_RESOURCE_DATA_PROP_RESOURCE_DATA,
  MAP_RESOURCE_PROP_API_FETCH,
  MAP_RESOURCE_PROP_API_FETCH_ERROR,
  MAP_RESOURCE_PROP_DISABLE_AUTOLOAD,
} from './mapResourceProps.const';


const autoload = (componentInstance) => {

  const {
          props: {
                   [MAP_RESOURCE_PROP_DISABLE_AUTOLOAD]:   disableAutoload,
                   [MAP_RESOURCE_PROP_API_FETCH]:          apiFetch,
                   [MAP_RESOURCE_PROP_API_FETCH_ERROR]:    fetchError,
                   [MAP_RESOURCE_DATA_PROP_RESOURCE_DATA]: resourceData,
                 }
        } = componentInstance;

  if (resourceData || fetchError || disableAutoload) {

    return;

  }

  apiFetch();

};


const autoloader = (/* Reserved for future config */) => compose(
  setDisplayName('Autoload'),
  lifecycle({

    componentDidMount() {

      autoload(this);

    },

    componentDidUpdate() {

      autoload(this);

    }

  }),
);


export default autoloader;


// WEBPACK FOOTER //
// ./src/components/resources/autoloader.js